"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LayersSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var LayersSVG = function LayersSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    d: "M3 11.73l11.94 7.39a2.09 2.09 0 002.22 0l11.94-7.39a2 2 0 00-.1-3.4L17 1.76a2.13 2.13 0 00-2 0L3 8.33a2 2 0 000 3.4z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M28.47 15.32L16 23 3.61 15.27A1 1 0 102.51 17l12.38 7.7a2.09 2.09 0 002.22 0L29.52 17a1 1 0 00.31-1.41 1 1 0 00-1.36-.27z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M28.47 20.8L16 28.51 3.61 20.75a1 1 0 00-1.1 1.77l12.38 7.66a2.09 2.09 0 002.22 0l12.41-7.67a1 1 0 00.31-1.41 1 1 0 00-1.36-.3z"
  }));
};
exports.LayersSVG = LayersSVG;
LayersSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(LayersSVG);
exports.default = _default;